import { Helmet } from 'react-helmet';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Container, Card, CardContent, TextField, Typography, SvgIcon, InputAdornment
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Search as SearchIcon } from 'react-feather';
import Modal from '@material-ui/core/Modal';
import "./style.scss";
import AccountProfile from "src/components/account/AccountProfile";
import AccountProfileDetails from "src/components/account/AccountProfileDetails";
import AccountProfileEdit from "src/components/account/AccountProfileEdit";
import { EVENT_API, SEARCH_EVENTID_API } from "../../apiContants";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    height: "25px!important",
    paddingTop: "5px!important",
  },
  padding: {
    paddingTop: "15px!important",
  },
  buttonsearch: {
    marginTop: "15px!important",
    marginLeft: "15px!important",
  },
  buttonclear: {
    marginTop: "15px!important",
    width: "130px",
  },
  buttonshow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    backgroundColor: "#5664d2!important",
    color: "white!important",
    borderRadius: "0px!important",
  },
  papervalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    color: "black!important",
    borderRadius: "0px!important",
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
}));

const Event = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [reg, regSet] = useState(Array);
  const [data, dataSet] = useState(Array);
  const [value, setValues] = React.useState({
    name: "",
  });
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);

  const handleOpenEdit = async (item, idx) => {
    dataSet(item);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const Getevent = async () => {
    const listevent = await axios.get(EVENT_API);
    const ListEvent = listevent.data.reports;
    regSet(ListEvent);
  };
  const DeleteEvent = async (item, idx) => {
    const Delete = await axios.delete(SEARCH_EVENTID_API + item.id);
    setLoading(!loading);
  };
  useEffect(() => {
    Getevent();
  }, [loading]);
  const body = (
    <Box
      sx={{
        backgroundColor: "background.default",
        minHeight: "100%",
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <AccountProfileDetails />
      </Container>
    </Box>
  );
  const bodyEdit = (
    <Box
      sx={{
        backgroundColor: "background.default",
        minHeight: "100%",
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <AccountProfileEdit edit={data} />
      </Container>
    </Box>
  );

  return (
    <>
      <Helmet>
        <title>Notice/ Event Manager</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ mt: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ maxWidth: 1200 }}>
                  <Grid spacing={3} container>
                    <Grid className={classes.padding} item xs={4}>
                      <h2>Notice/ Event Manager</h2>
                    </Grid>
                    <Button onClick={() => handleOpen()}>Add new</Button>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Box>
          {reg.map((item, idx) => (
            <Box sx={{ mt: 3 }}>
              <Card>
                <CardContent>
                  <Box sx={{ maxWidth: 1200, height: 100 }}>
                    <Grid spacing={3} container>
                      <Grid className={classes.padding} item xs={3}>
                        <Card
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "95px",
                            width: "200px",
                          }}
                        >
                          <CardContent>
                            <img className="banner" src={item.banner} />
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid className={classes.padding} item xs={4}>
                        <h2>{item.title}</h2>
                      </Grid>
                      <Grid className={classes.padding} item xs={3}>
                        {/* <h2>{item.content}</h2> */}
                      </Grid>
                      <Grid className={classes.padding} item xs={1}>
                        <Button
                          onClick={() => handleOpenEdit(item, idx)}
                          color="primary"
                        >
                          Edit
                        </Button>
                      </Grid>
                      <Grid className={classes.padding} item xs={1}>
                        <Button onClick={() => DeleteEvent(item, idx)}>
                          Delete
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Container>
      </Box>
      <Box textAlign="center">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </Box>
      <Box textAlign="center">
        <Modal
          open={openEdit}
          onClose={handleCloseEdit}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {bodyEdit}
        </Modal>
      </Box>
    </>
  );
};

export default Event;
